import React, { useState } from "react";
import "./step2.css";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { FaAngleRight } from "react-icons/fa";
import PhoneInput from "react-phone-number-input";
import CustomTitleSelect from "../CustomTitleComponent";
import CustomSelect from "../CustomSelect";
import { defaultGuest, Guest, Room } from "./HotelBookingPage";
import message from "antd/es/message";

interface Step3Props {
  checkIn: Date;
  checkOut: Date;
  selectedRoom: Room;
  occupancy: "Single" | "Double";
  setOccupancy: (val: "Single" | "Double") => void;
  rooms: number;
  setRooms: (val: number) => void;
  guests: Guest[];
  setGuests: React.Dispatch<React.SetStateAction<Guest[]>>;
  airportTransfer: boolean;
  setAirportTransfer: (val: boolean) => void;
  paymentOption: string;
  setPaymentOption: (val: string) => void;
  onNext: () => void;
  onBack: () => void;
}

const Step3: React.FC<Step3Props> = ({
  checkIn,
  checkOut,
  selectedRoom,
  occupancy,
  setOccupancy,
  rooms,
  setRooms,
  guests,
  setGuests,
  airportTransfer,
  setAirportTransfer,
  paymentOption,
  setPaymentOption,
  onNext,
  onBack,
}) => {
  const [currentGuestIndex, setCurrentGuestIndex] = useState(0);
  const [errors, setErrors] = useState<{ [key: number]: string[] }>({});

  const validateGuest = (guest: Guest) => {
    const missing: string[] = [];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!guest.firstName) missing.push("First Name");
    if (!guest.lastName) missing.push("Last Name");
    if (!guest.mobile) missing.push("Mobile");
    if (!guest.email) {
      missing.push("Email");
    } else if (!emailRegex.test(guest.email)) {
      missing.push("Invalid Email");
    }

    return missing;
  };

  const handleFinalSubmit = () => {
    // const validationErrors = validateGuest(guests[currentGuestIndex]);
    // if (validationErrors.length) {
    //   setErrors((prev) => ({ ...prev, [currentGuestIndex]: validationErrors }));
    //   return;
    // }

    // // Auto-set if only one guest
    // if (guests.length === 1) {
    //   const updated = [...guests];
    //   updated[0].primary = true;
    //   setGuests(updated);
    // }

    // // Ensure at least one primary guest
    // const hasPrimary = guests.some((g) => g.primary);
    // if (!hasPrimary) {
    //   message.error("Please select a primary guest before continuing.");
    //   return;
    // }

    onNext();
  };

  const nights =
    checkIn && checkOut
      ? (checkOut.getTime() - checkIn.getTime()) / (1000 * 3600 * 24)
      : 0;

  const totalPrice =
    guests.reduce((sum, guest) => {
      const rate =
        guest.occupancy === "Double"
          ? selectedRoom.double
          : selectedRoom.single;
      return sum + rate * nights;
    }, 0) + (airportTransfer ? 130 : 0); //450 in AED

  const allGuestsComplete = guests.every((guest) => {
    return (
      guest.firstName.trim() &&
      guest.lastName.trim() &&
      guest.mobile.trim() &&
      guest.email.trim()
    );
  });

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="step2-container">
      <div className="step2-content">
        <div className="room-info">
          <div className="room-info-card">
            <div className="image-wrapper">
              {(selectedRoom.limitSingle != null ||
                selectedRoom.limitDouble != null) && (
                <div className="badge-row">
                  <span className="badge limited">Limited Slots</span>
                </div>
              )}
              <img src={selectedRoom.image} alt={selectedRoom.name} />
            </div>
            <div className="content">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline", // key fix
                  gap: 8,
                  marginBottom: 12,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: 18,
                    fontWeight: 700,
                    color: "#022c22",
                  }}
                >
                  {selectedRoom.name.toUpperCase()}
                </h3>
                <a
                  style={{
                    fontSize: 12,
                    color: "#4f46e5",
                    textDecoration: "underline",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                  onClick={onBack}
                >
                  Change your selection
                </a>
              </div>

              <div className="prices">
                <div className="price-row">
                  <span>Single Occupancy</span>
                  <span className="price">
                    ${selectedRoom.single.toFixed(2)}
                  </span>
                </div>
                <div className="price-row">
                  <span>Double Occupancy</span>
                  <span className="price">
                    ${selectedRoom.double.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="room-info-card summary">
            <h3
              style={{
                margin: 0,
                fontSize: 18,
                fontWeight: 700,
                color: "#022c22",
              }}
            >
              Summary
            </h3>

            <div style={{ fontSize: 14, color: "#333" }}>
              <div className="prices">
                <div className="price-row">
                  <span>Total nights</span>
                  <span className="price">{nights} nights</span>
                </div>
                <div className="price-row">
                  <span>No. of Rooms</span>
                  <span className="price">{rooms}</span>
                </div>
              </div>

              {guests.map((guest, i) => {
                const rate =
                  guest.occupancy === "Double"
                    ? selectedRoom.double
                    : selectedRoom.single;
                const subtotal = rate * nights;

                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      color: "#ADADAD",
                      marginBottom: 6,
                      paddingLeft: 24,
                    }}
                  >
                    <span>
                      Room {i + 1} ({guest.occupancy})
                    </span>
                    <span>
                      $
                      {rate.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      × {nights} nights = $
                      {subtotal.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                );
              })}

              <div className="prices">
                {airportTransfer && (
                  <div className="price-row">
                    <span>Airport Transfer</span>
                    <span className="price">$130.00</span>
                  </div>
                )}
              </div>

              <div
                style={{
                  borderTop: "1px solid #ddd",
                  marginTop: 12,
                  marginBottom: 8,
                }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#16a34a",
                }}
              >
                <span>Total</span>
                <span>
                  $
                  {totalPrice.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>

            <p
              className="note"
              style={{
                marginTop: 24,
                marginBottom: 0,
                fontSize: 13,
                color: "#666",
                textAlign: "center",
              }}
            >
              All rates include breakfast and applicable taxes.
            </p>
          </div>
        </div>

        <div className="form-container">
          <div className="form-row-dates-inline">
            <div className="form-group-dates">
              <label style={{ paddingBottom: 4 }}>Check-in Date</label>
              <label className="check-in-label">
                {" "}
                {checkIn.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </label>
            </div>
            <div className="form-group-dates">
              <label style={{ paddingBottom: 4 }}>Check-out Date</label>
              <label className="check-in-label">
                {" "}
                {checkOut.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </label>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #ddd", paddingBottom: 20 }} />

          {/* <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            <h4 className="guest-title-details">Extras and Payment Options</h4>
            <span className="room-note">
              Please provide accurate information as per your passport
            </span>
          </div> */}

          <SwitchTransition mode="out-in">
            <CSSTransition
              key={currentGuestIndex}
              timeout={300}
              classNames="slide"
            >
              <div>
                <div
                  className="form-row"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // gap: 10,
                    width: "100%",
                  }}
                >
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ flex: "0 0 180px" }}>
                      <label
                        htmlFor="rooms"
                        style={{
                          display: "block",
                          fontWeight: 500,
                          marginBottom: 2,
                          width: isMobile ? "100%" : "320px",
                          fontSize: 14,
                        }}
                      >
                        Do you require an airport transfer?
                      </label>
                      <CustomSelect
                    label="Airport Transfer"
                    options={["Yes", "No"]}
                    value={airportTransfer ? "Yes" : "No"}
                    onChange={(val) => setAirportTransfer(val === "Yes")}
                  />
                    </div>

                    <span
                      className="room-note"
                      style={{
                        fontSize: 14,
                        marginBottom: 13,
                      }}
                    >
                      An additional fee of $130.00 will apply
                    </span>
                  </div> */}
                </div>
                <div className="form-row">
                  <label>How would you like to pay?</label>
                  <CustomSelect
                    label="Payment Option"
                    options={["Pay by Link", "Bank Transfer"]}
                    value={paymentOption}
                    onChange={(val) => setPaymentOption(val)}
                  />
                </div>
              </div>
            </CSSTransition>
          </SwitchTransition>
        </div>
      </div>

      {/* Inline button group for desktop */}
      <div
        className="inline-button-group next-button"
        style={{
          backgroundColor: "#fff",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <button onClick={onBack}>Back: Dates & Rooms</button>
        <button
          onClick={handleFinalSubmit}
          disabled={!allGuestsComplete}
          style={{
            opacity: allGuestsComplete ? 1 : 0.5,
            cursor: allGuestsComplete ? "pointer" : "not-allowed",
          }}
        >
          Next: Review Reservation
        </button>
      </div>

      {/* Floating button group for mobile */}
      <div className="floating-button-group">
        <button onClick={onBack}>Back</button>
        <button
          onClick={handleFinalSubmit}
          disabled={!allGuestsComplete}
          style={{
            opacity: allGuestsComplete ? 1 : 0.5,
            cursor: allGuestsComplete ? "pointer" : "not-allowed",
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step3;
